/**
 * All global frontend scripts required should be included here.
 *
 * This is the file that Webpack is compiling into main.[hash].js
 */

import "../../pubstack/assets/tvguide"; // Load before footer scss
import "./sass/footer.scss";

import expandedMenu from "./js/expanded-menu";
import initializeCarousel from "./js/carousel-products";
import VideoJw from "../../pubstack/assets/js/video-jw";
import IasVideo from "../../pubstack/assets/js/ads/ias-video";
import EmailPreferences from "./js/newsletter/preferences";
import EmailUnsubscribe from "./js/newsletter/unsubscribe";
import SubscribeModal from "./js/newsletter/modal";
import NewsletterBlock from "./js/newsletter/block";
import LoadMore from "../../pubstack/assets/js/blocks/load-more";
import articleOembed from "../../pubstack/assets/js/article/article-oembed";

new IasVideo();

new VideoJw().init();

require("../../pubstack/assets/js/ads/cls");
require("./js/newsletter/cordial-footer");

$(function () {
  expandedMenu();
  initializeCarousel();

  // Newsletter Subscribe
  EmailPreferences.init();
  SubscribeModal.init();
  EmailUnsubscribe.init();
  NewsletterBlock.init();
  LoadMore();
  articleOembed();
});

const menu = ["#texture-menu", "#topics-menu", "#products-menu"];

// Loop through each menu selector
menu.forEach(function (menuSelector) {
  const $mainMenu = jQuery("#sub-site-navigation .menu").find(menuSelector);
  if (window.matchMedia("(max-width: 767px)").matches) {
    $($mainMenu).find("ul:first").hide(); // Only select the first ul
    $mainMenu.on("click", function (e) {
      e.preventDefault();
      // Toggle visibility of the first ul
      $(this).find("ul:first").toggle();
      $(this).toggleClass("tabs-list");
    });

    // Prevent hiding parent list when clicking on child list items
    $mainMenu.find("ul ul , .mega-sub-menu3").on("click", function (e) {
      e.stopPropagation(); // Prevent the event from bubbling up to the parent
    });

    // Toggle visibility of inner ul when clicking on mega-block-title
    $mainMenu.find(".mega-block-title").on("click", function (e) {
      e.preventDefault();
      // Toggle visibility of the inner ul
      $(this).parent().find("ul:first").toggle();
      $(this).toggleClass("open");
    });
  } else {
    // Attach mouseenter event
    $mainMenu.on("mouseenter", function () {
      jQuery("#sub-site-navigation .menu li ul").css("display", "none");
      jQuery(this).find("ul").css("display", "block");
      $(this).addClass("tabs-list-desktop");
      jQuery("#content").css("z-index", "-1");
    });

    // Attach mouseleave event to hide the current submenu
    $mainMenu.on("mouseleave", function () {
      jQuery(this).find("ul").css("display", "none");
      jQuery("#content").css("z-index", "auto");
      $(this).removeClass("tabs-list-desktop");
    });
  }
});
